<div
  class="price-reco-block price-table"
  *ngFor="let quota of quotasToShow | keyvalue"
>
  <table class="table survey-detail-table">
    <thead>
      <tr>
        <th class="text-left">
          <span class="np_tp_row">
            <span>{{ quota.key }}</span>
          </span>
        </th>
        <th class="text-center">Current CPI</th>
        <th class="text-center rcpi-th">Recommended CPI</th>
        <th class="text-center">
          {{
            surveyData.click_balancing === 1
              ? 'Click
          Fielded Vs Click Goal'
              : 'Fielded Vs Goal'
          }}
        </th>
        <th class="text-center min-width-col-2"></th>
      </tr>
    </thead>
    <tbody *ngFor="let item of quota.value; let i = index">
      <tr>
        <td class="text-left" title="{{ item.marker }}">
          <span>
            {{ item.quota_title }}
          </span>
        </td>
        <td class="text-center">
          {{
            item.qbp && item.qbp.cpi
              ? (item.qbp.cpi | currency : surveyData.currencySymbol)
              : '$ -----'
          }}
        </td>
        <td class="text-center rcpi-td">
          <table class="table-price-reco-diff-apply">
            <th></th>
            <tbody>
              <tr>
                <td
                  *ngIf="
                    item &&
                    item.diffCpi > 0 &&
                    item.achieved !== item.required_count
                  "
                  class="text-center data-apply diff-green"
                >
                  +{{ item.diffCpi }}
                </td>
                <td
                  *ngIf="
                    item &&
                    item.diffCpi < 0 &&
                    item.achieved !== item.required_count
                  "
                  class="text-center data-apply diff-red"
                >
                  {{ item.diffCpi }}
                </td>
                <td
                  *ngIf="
                    (item && item.diffCpi === 0) ||
                    (item &&
                      item.qbp &&
                      !item.qbp.cpi &&
                      item.achieved !== item.required_count)
                  "
                  class="text-center data-apply"
                >
                  <div class="blank-td"></div>
                </td>
                <td
                  *ngIf="item.achieved === item.required_count"
                  class="text-center data-apply"
                >
                  <div class="blank-td">-</div>
                </td>
                <td
                  class="text-center data-apply"
                  *ngIf="item.achieved !== item.required_count"
                >
                  {{ surveyData.fx ? surveyData.currencySymbol : '$' }}
                  {{ item.priceRecommendCpi }}
                </td>
                <td
                  class="text-center data-apply"
                  *ngIf="item.achieved === item.required_count"
                >
                  -
                </td>
                <td class="text-center data-apply-button">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <button
                    class="btn btn-primary btn-round-sm btn-sm apply-rcpi-button"
                    [disabled]="
                      item.diffCpi === 0 ||
                      (item && item.qbp && !item.qbp.cpi) ||
                      item.achieved === item.required_count
                    "
                    (click)="applyRecommendedCpi(item)"
                  >
                    {{
                      item.achieved === item.required_count
                        ? 'Quota Complete'
                        : 'Apply'
                    }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
        <td class="text-center">
          {{
            surveyData.click_balancing === 1
              ? item.buyer_valid_clks
              : item.achieved
          }}&nbsp;|&nbsp;{{ item.required_count }}
        </td>
        <td class="text-center"></td>
      </tr>
    </tbody>
  </table>
</div>
